export * from "./user.constants";
export * from "./mode.constants";
export * from "./blog.constants";
export * from "./serverResponse/serverResponse.constants";

export const globalConstants = {
  EMPTY_STRING: "",
  SUCCESS: "_SUCCESS",
  FAILIUR: "_FAILIUR",
  FILTER_EXPRESSION: "aXNBY3RpdmU9PXRydWV8fGlzQWN0aXZlPT1mYWxzZQ==",
  SORT: {
    ASC: "asc",
    DESC: "desc",
  },
};

export const TOAST_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
};
